import type { FindUserReservationsExternalFlightReservation } from "@/app/lib/types/codegen";
import { Chip, type ChipOwnProps } from "@mui/material";
import { useTranslations } from "use-intl";

type Props = {
  status: FindUserReservationsExternalFlightReservation["status"];
};

const StatusToColorMapping: {
  [key in FindUserReservationsExternalFlightReservation["status"]]: ChipOwnProps["color"];
} = {
  IN_PROGRESS: "warning",
  TICKET_ISSUED: "success",
  OK: "success",
  BOOKED: "success",
  REFUNDED: "error",
};

const StatusLabels: {
  [key in FindUserReservationsExternalFlightReservation["status"]]: string;
} = {
  IN_PROGRESS: "reservations.orderStatuses.inProgress",
  TICKET_ISSUED: "reservations.orderStatuses.ticketIssued",
  OK: "reservations.orderStatuses.booked",
  BOOKED: "reservations.orderStatuses.booked",
  REFUNDED: "reservations.orderStatuses.refunded",
};

export const OrderLabel = ({ status }: Props) => {
  const t = useTranslations();
  return (
    <Chip
      color={StatusToColorMapping[status]}
      label={t(StatusLabels[status])}
    />
  );
};
